export const smsTypes = {
    TOGGLE: "TOGGLE",
    SET_MSG: "SET_MSG",
};
